var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-collapse-item",
    {
      ref: "collapseItem",
      staticClass: "my-3 collapse-item section bg-gray",
      attrs: {
        auto: "",
        "expanded-icon": "fas fa-chevron-circle-right color-gray-7",
        "minimized-icon": "fas fa-chevron-circle-down color-warning",
        "parent-id": "svp-collapse",
        "read-only-icon": "fas fa-plus-circle color-gray-2",
        "start-expanded": "",
        title: "SVP - Nivel de Preparación Vocacional"
      },
      on: {
        expandButtonClick: function($event) {
          return _vm.$emit("expandButtonClick")
        }
      }
    },
    [
      _c("div", { staticClass: "bg-white p-3 rounded" }, [
        _c("div", { staticClass: "bg-light p-3 rounded mb-3 border" }, [
          _c(
            "div",
            { staticClass: "bg-white svp-legend-box" },
            _vm._l(_vm.legendGroups, function(group, index) {
              return _c(
                "div",
                {
                  key: group?.name,
                  staticClass: "row align-items-center mb-3",
                  class: index < 2 ? "border-bottom pb-3" : ""
                },
                [
                  _c("div", { staticClass: "col-md-2 font-weight-bold" }, [
                    _vm._v(" " + _vm._s(group?.name) + " ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-md-10 d-flex flex-wrap" },
                    _vm._l(group.legends, function(legend) {
                      return _c(
                        "span",
                        {
                          key: legend.id,
                          staticClass: "svp-chip mr-3 mb-2",
                          style: _vm.getLegendStyle(legend)
                        },
                        [_vm._v(" " + _vm._s(legend?.name) + " ")]
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        ]),
        _c(
          "div",
          { staticClass: "svp-item-card p-3" },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-6 mb-3" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          name: "Tipo de Trabajo Requerido por la Profesión",
                          rules: "required"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("label", [
                                    _vm._v(
                                      "Tipo de Trabajo Requerido por la Profesión:"
                                    )
                                  ]),
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isReadOnly,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.workTypes,
                                      placeholder: "Seleccione",
                                      value: _vm.item.workType
                                    },
                                    on: { input: _vm.onWorkTypeChange }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1809267217
                        )
                      })
                    : _c("div", [
                        _c("label", [
                          _vm._v("Tipo de Trabajo Requerido por la Profesión:")
                        ]),
                        _c("span", { staticClass: "d-block mt-1 text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(_vm.item.workType?.name)) +
                              " "
                          )
                        ])
                      ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 mb-3" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          name: "Nivel Requerido de la Profesión",
                          rules: "required"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("label", [
                                    _vm._v("Nivel Requerido de la Profesión:")
                                  ]),
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: "",
                                      disabled:
                                        _vm.isReadOnly || !_vm.item.workType,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.filteredLevels,
                                      placeholder: "Seleccione",
                                      value: _vm.item.requiredLevel
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.updateItem(
                                          "requiredLevel",
                                          $event
                                        )
                                      }
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          740534987
                        )
                      })
                    : _c("div", [
                        _c("label", [
                          _vm._v("Nivel Requerido de la Profesión:")
                        ]),
                        _c("span", { staticClass: "d-block mt-1 text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(_vm.item.requiredLevel?.name)
                              ) +
                              " "
                          )
                        ])
                      ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 mb-3" },
                [
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        attrs: {
                          name: "Perfil del Evaluado",
                          rules: "required"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("label", [_vm._v("Perfil del Evaluado:")]),
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isReadOnly,
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.filteredNotParentLevels,
                                      placeholder: "Seleccione",
                                      value: _vm.item.evaluatedLevel
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.updateItem(
                                          "evaluatedLevel",
                                          $event
                                        )
                                      }
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3571554130
                        )
                      })
                    : _c("div", [
                        _c("label", [_vm._v("Perfil del Evaluado:")]),
                        _c("span", { staticClass: "d-block mt-1 text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(_vm.item.evaluatedLevel?.name)
                              ) +
                              " "
                          )
                        ])
                      ])
                ],
                1
              ),
              _c("div", { staticClass: "col-md-6 mb-3" }, [
                _c("label", [_vm._v("Nivel de Alcance:")]),
                _c("div", [
                  _vm.getLegendByLevel(_vm.item.evaluatedLevel)
                    ? _c(
                        "span",
                        {
                          staticClass: "svp-chip",
                          style: _vm.getLegendStyle(
                            _vm.getLegendByLevel(_vm.item.evaluatedLevel)
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getLegendByLevel(_vm.item.evaluatedLevel)
                                  ?.name
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ]),
            _c("hr"),
            _c("validation-provider", {
              attrs: { name: "Resultado del Pareo", rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("input", {
                        attrs: { type: "hidden" },
                        domProps: { value: _vm.item.selectedAnswer }
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap svp-answer-wrapper" },
                        _vm._l(_vm.answers, function(answer) {
                          return _c(
                            "button",
                            {
                              key: `svp-answer-${answer.id}`,
                              staticClass: "svp-answer-btn",
                              class: {
                                active:
                                  _vm.item.selectedAnswer &&
                                  _vm.item.selectedAnswer.id === answer.id
                              },
                              attrs: {
                                disabled: _vm.isReadOnly,
                                type: "button"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.updateItem(
                                    "selectedAnswer",
                                    answer
                                  )
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "far fa-check-circle d-block mb-1"
                              }),
                              _vm._v(" " + _vm._s(answer?.name) + " ")
                            ]
                          )
                        }),
                        0
                      ),
                      _c("small", { staticClass: "text-danger d-block mt-1" }, [
                        _vm._v(_vm._s(errors[0]))
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mt-3" },
          [
            _c("label", [_vm._v("Observaciones:")]),
            _c("custom-text-area", {
              attrs: {
                "count-classes": ["d-block", "small-counter", "text-right"],
                disabled: _vm.isReadOnly,
                maxlength: 5000,
                placeholder: "Comentario",
                "show-char-count": ""
              },
              model: {
                value: _vm.model.comment,
                callback: function($$v) {
                  _vm.$set(_vm.model, "comment", $$v)
                },
                expression: "model.comment"
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }